import { render, staticRenderFns } from "./c_is_show.vue?vue&type=template&id=54957720&scoped=true"
import script from "./c_is_show.vue?vue&type=script&lang=js"
export * from "./c_is_show.vue?vue&type=script&lang=js"
import style0 from "./c_is_show.vue?vue&type=style&index=0&id=54957720&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54957720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54957720')) {
      api.createRecord('54957720', component.options)
    } else {
      api.reload('54957720', component.options)
    }
    module.hot.accept("./c_is_show.vue?vue&type=template&id=54957720&scoped=true", function () {
      api.rerender('54957720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/components/mobileConfigRight/c_is_show.vue"
export default component.exports